export const optionButtonStyles = {
  edgeDropdown: {
    title: {
      background: "transparent",
      color: "white !important",
      borderRadius: "5px",
      border: "2px solid white !important",
    },
    dropdownItemSelectedAndDisabled: {
      color: "white",
    },
    caretDown: {
      color: "white !important",
    },
    dropdownItem: {
      background: "rgb(84, 99, 173)  !important",
      color: "white",
      border: "none",
    },
    dropdownItemSelected: {
      background: "#4144a0 !important",
      color: "white",
      border: "none",
    },
  },
  algoDropdown: {
    title: {
      background: "transparent",
      color: "white !important",
      borderRadius: "5px",
      border: "2px solid white !important",
      width: "180px",
    },
    dropdownItemHeader: {
      backgroundImage: "linear-gradient(45deg, #ffffff, #5463ad 100%)",
      color: "black",
    },
    dropdownItemSelectedAndDisabled: {
      color: "white",
    },
    caretDown: {
      color: "white !important",
    },

    dropdownItem: {
      background: "rgb(84, 99, 173)  !important",
      color: "white",
      border: "none",
    },
    dropdownItemSelected: {
      background: "#4144a0 !important",
      color: "white",
      border: "none",
    },
  },
};
export const sliderOptions = {
  titleLabel: { color: "white" },
  valueLabel: { color: "white" },
  inactiveSection: { background: "white" },
  activeSection: {
    backgroundImage: "linear-gradient(45deg,#4039ad,#0e8ecc 159%)",
  },
};
